import { Model, Msg, Model_Init } from "./Types.fs.js";
import { ofArray, singleton } from "../../../fable_modules/fable-library-js.4.19.0/List.js";
import { eitherAsResult } from "../../../../Bfs.Web.Portale/Server.fs.js";
import { Settings } from "../../../Service.fs.js";
import { GlobalMessageBox_SuccessWithTitle, GlobalMessageBox, GlobalMessageBoxButton, GlobalMessageBoxButtonType, GlobalMessageType, GlobalMsg, GlobalMessageBox_Error_Z721C83C5 } from "../../../../Bfs.Web.Portale/Types.fs.js";
import { toString } from "../../../fable_modules/fable-library-js.4.19.0/Types.js";
import { Cmd_batch, Cmd_none } from "../../../fable_modules/Fable.Elmish.4.2.0/cmd.fs.js";
import { some } from "../../../fable_modules/fable-library-js.4.19.0/Option.js";
import { webPrint } from "../../../../Bfs.Web.Portale/Preview.fs.js";

export function init(page, user, lastModel) {
    if (user == null) {
        throw new Error("Usersession is None");
    }
    else {
        return [Model_Init(), singleton((dispatch) => {
            dispatch(new Msg(0, []));
        })];
    }
}

export function update(msg, model) {
    let msg_1, msg_7, msg_5, msg_3, msg_13, msg_11, msg_9;
    switch (msg.tag) {
        case 0:
            return [model, eitherAsResult(Settings.GetSettings, undefined, (Item) => (new Msg(1, [Item])))];
        case 1:
            if (msg.fields[0].tag === 1) {
                return [model, (msg_1 = (new Msg(7, [new GlobalMsg(3, [GlobalMessageBox_Error_Z721C83C5(toString(msg.fields[0].fields[0]))])])), singleton((dispatch) => {
                    dispatch(msg_1);
                }))];
            }
            else {
                return [new Model(msg.fields[0].fields[0].DokumentenabrufSettings), Cmd_none()];
            }
        case 2:
            return [model, eitherAsResult(Settings.TryDokumentenabruf, [msg.fields[0], msg.fields[1]], (x) => (new Msg(3, [msg.fields[0], msg.fields[1], x])))];
        case 3:
            if (msg.fields[2].tag === 0) {
                const copyOfStruct = msg.fields[2].fields[0];
                if (copyOfStruct.tag === 0) {
                    return [model, (msg_7 = (new Msg(7, [new GlobalMsg(3, [new GlobalMessageBox(new GlobalMessageType(1, []), msg.fields[1] ? "Dokumentenabruf abonnieren" : "Dokumentenabruf beenden", copyOfStruct.fields[0], ofArray([new GlobalMessageBoxButton(new GlobalMessageBoxButtonType(2, []), "Abbrechen", undefined, true), new GlobalMessageBoxButton(new GlobalMessageBoxButtonType(0, []), "Drucken", some(new Msg(6, [copyOfStruct.fields[0]])), false), new GlobalMessageBoxButton(new GlobalMessageBoxButtonType(3, []), msg.fields[1] ? "Kostenpflichtig abonnieren" : "Dokumentenabruf beenden", some(new Msg(4, [msg.fields[0], msg.fields[1]])), true)]))])])), singleton((dispatch_3) => {
                        dispatch_3(msg_7);
                    }))];
                }
                else {
                    return [model, (msg_5 = (new Msg(7, [new GlobalMsg(3, [GlobalMessageBox_Error_Z721C83C5(copyOfStruct.fields[0])])])), singleton((dispatch_2) => {
                        dispatch_2(msg_5);
                    }))];
                }
            }
            else {
                return [model, (msg_3 = (new Msg(7, [new GlobalMsg(3, [GlobalMessageBox_Error_Z721C83C5(toString(msg.fields[2].fields[0]))])])), singleton((dispatch_1) => {
                    dispatch_1(msg_3);
                }))];
            }
        case 6: {
            webPrint("Verrechnungsfristverschiebung", msg.fields[0]);
            return [model, Cmd_none()];
        }
        case 4:
            return [model, eitherAsResult(Settings.SetDokumentenabruf, [msg.fields[0], msg.fields[1]], (x_1) => (new Msg(5, [msg.fields[0], msg.fields[1], x_1])))];
        case 5:
            if (msg.fields[2].tag === 0) {
                const copyOfStruct_1 = msg.fields[2].fields[0];
                if (copyOfStruct_1.tag === 0) {
                    return [model, Cmd_batch(ofArray([(msg_13 = (new Msg(7, [new GlobalMsg(3, [GlobalMessageBox_SuccessWithTitle("Dokumentenabruf erfolgreich abonniert", copyOfStruct_1.fields[0])])])), singleton((dispatch_6) => {
                        dispatch_6(msg_13);
                    })), singleton((dispatch_7) => {
                        dispatch_7(new Msg(0, []));
                    })]))];
                }
                else {
                    return [model, (msg_11 = (new Msg(7, [new GlobalMsg(3, [GlobalMessageBox_Error_Z721C83C5(copyOfStruct_1.fields[0])])])), singleton((dispatch_5) => {
                        dispatch_5(msg_11);
                    }))];
                }
            }
            else {
                return [model, (msg_9 = (new Msg(7, [new GlobalMsg(3, [GlobalMessageBox_Error_Z721C83C5(toString(msg.fields[2].fields[0]))])])), singleton((dispatch_4) => {
                    dispatch_4(msg_9);
                }))];
            }
        default:
            return [model, Cmd_none()];
    }
}

//# sourceMappingURL=State.fs.js.map
